var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-config-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("general.system"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "system" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c(
            "div",
            { staticClass: "admin-config-panel__inner" },
            [
              _c("show-tip", {
                attrs: {
                  module: "configuration",
                  tip: "tip_system_configuration",
                },
              }),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "mt-3",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      return _vm.configForm.errors.clear($event.target.name)
                    },
                  },
                },
                [
                  _c(
                    "section",
                    {
                      staticClass: "admin-config-section",
                      attrs: { "aria-label": _vm.trans("general.system") },
                    },
                    [
                      _c("h4", { staticClass: "admin-config-section__title" }, [
                        _vm._v(_vm._s(_vm.trans("general.system"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "admin-config-section__description" },
                        [
                          _vm._v(
                            "Global display, localization, and feature toggles that affect the whole admin experience."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.color_theme"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.color_theme,
                                    expression: "configForm.color_theme",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "color_theme",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables.color_themes,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "color_theme",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.direction"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.direction,
                                    expression: "configForm.direction",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "direction",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables.directions,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "direction",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.date_format"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.date_format,
                                    expression: "configForm.date_format",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "date_format",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables.date_formats,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "date_format",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.time_format"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.time_format,
                                    expression: "configForm.time_format",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "time_format",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables.time_formats,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "time_format",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "configuration.notification_position"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.notification_position,
                                    expression:
                                      "configForm.notification_position",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "notification_position",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables
                                  .notification_positions,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "notification_position",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.getConfig("multilingual")
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-md-6 form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(_vm._s(_vm.trans("locale.locale"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.configForm.locale,
                                        expression: "configForm.locale",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.configForm,
                                          "locale",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.systemConfigVariables.locales,
                                    function (option) {
                                      return _c(
                                        "option",
                                        { domProps: { value: option.value } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(option.text) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c("show-error", {
                                  attrs: {
                                    "form-name": _vm.configForm,
                                    "prop-name": "locale",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.timezone"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.timezone,
                                    expression: "configForm.timezone",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "timezone",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.systemConfigVariables.timezones,
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option.value } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.text) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "timezone",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.page_length"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.page_length,
                                    expression: "configForm.page_length",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.configForm,
                                      "page_length",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.getConfig("pagination"),
                                function (option) {
                                  return _c(
                                    "option",
                                    { domProps: { value: option } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            option +
                                              " " +
                                              _vm.trans("general.per_page")
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "page_length",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.footer_credit"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.configForm.footer_credit,
                                  expression: "configForm.footer_credit",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "footer_credit",
                                placeholder: _vm.trans(
                                  "configuration.footer_credit"
                                ),
                              },
                              domProps: { value: _vm.configForm.footer_credit },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.configForm,
                                    "footer_credit",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.configForm,
                                "prop-name": "footer_credit",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "admin-config-section",
                      attrs: {
                        "aria-label": _vm.trans(
                          "configuration.maintenance_mode"
                        ),
                      },
                    },
                    [
                      _c("h4", { staticClass: "admin-config-section__title" }, [
                        _vm._v(
                          _vm._s(_vm.trans("configuration.maintenance_mode"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "admin-config-section__description" },
                        [
                          _vm._v(
                            "Feature toggles control which platform modules and diagnostics are available."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.trans("configuration.https")) + " "
                                ),
                                _c("show-tip", {
                                  attrs: {
                                    type: "field",
                                    module: "configuration",
                                    tip: "tip_https",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.https,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "https", $$v)
                                    },
                                    expression: "configForm.https",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("configuration.error_display")
                                  ) + " "
                                ),
                                _c("show-tip", {
                                  attrs: {
                                    type: "field",
                                    module: "configuration",
                                    tip: "tip_error_log",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.error_display,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "error_display",
                                        $$v
                                      )
                                    },
                                    expression: "configForm.error_display",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("configuration.multilingual")
                                  ) + " "
                                ),
                                _c("show-tip", {
                                  attrs: {
                                    type: "field",
                                    module: "configuration",
                                    tip: "tip_multilingual",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.multilingual,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "multilingual",
                                        $$v
                                      )
                                    },
                                    expression: "configForm.multilingual",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.trans("configuration.ip_filter")) +
                                    " "
                                ),
                                _c("show-tip", {
                                  attrs: {
                                    type: "field",
                                    module: "configuration",
                                    tip: "tip_ip_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.ip_filter,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "ip_filter", $$v)
                                    },
                                    expression: "configForm.ip_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.activity_log"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.activity_log,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "activity_log",
                                        $$v
                                      )
                                    },
                                    expression: "configForm.activity_log",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.email_log"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.email_log,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "email_log", $$v)
                                    },
                                    expression: "configForm.email_log",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("configuration.email_template")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.email_template,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "email_template",
                                        $$v
                                      )
                                    },
                                    expression: "configForm.email_template",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.trans("configuration.todo"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.todo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "todo", $$v)
                                    },
                                    expression: "configForm.todo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                _vm._s(_vm.trans("configuration.message"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.message,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "message", $$v)
                                    },
                                    expression: "configForm.message",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.trans("configuration.backup"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.backup,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.configForm, "backup", $$v)
                                    },
                                    expression: "configForm.backup",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-6 form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("configuration.maintenance_mode")
                                  ) + " "
                                ),
                                _c("show-tip", {
                                  attrs: {
                                    type: "field",
                                    module: "configuration",
                                    tip: "tip_maintenance_mode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("switches", {
                                  attrs: {
                                    theme: "bootstrap",
                                    color: "success",
                                  },
                                  model: {
                                    value: _vm.configForm.maintenance_mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "maintenance_mode",
                                        $$v
                                      )
                                    },
                                    expression: "configForm.maintenance_mode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.configForm.maintenance_mode
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-md-6 form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "configuration.maintenance_mode_message"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("autosize-textarea", {
                                  staticClass: "form-control",
                                  attrs: {
                                    row: "1",
                                    placeholder: _vm.trans(
                                      "configuration.maintenance_mode_message"
                                    ),
                                    rows: "3",
                                    name: "maintenance_mode_message",
                                  },
                                  model: {
                                    value:
                                      _vm.configForm.maintenance_mode_message,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.configForm,
                                        "maintenance_mode_message",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "configForm.maintenance_mode_message",
                                  },
                                }),
                                _vm._v(" "),
                                _c("show-error", {
                                  attrs: {
                                    "form-name": _vm.configForm,
                                    "prop-name": "maintenance_mode_message",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "admin-config-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.trans("general.save")))]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Configure global display, localization, notifications, and platform feature toggles."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }